import api from "./api.config";

// Cadre APIs
export const cadreAPI = {
  getCadreMembers: async (params = {}) => {
    const response = await api.get("/cadre/members", { params });
    return response.data;
  },

  getAvailableCadreMembers: async (params = {}) => {
    const response = await api.get("/cadre/available-members", { params });
    return response.data;
  },

  getAllApplications: async (params = {}) => {
    const response = await api.get("/cadre/applications", { params });
    return response.data;
  },

  approveApplication: async (id) => {
    const response = await api.post(`/cadre/applications/${id}/approve`);
    return response.data;
  },

  rejectApplication: async (id, reason) => {
    const response = await api.post(`/cadre/applications/${id}/reject`, {
      reason,
    });
    return response.data;
  },

  deleteApplication: async (id) => {
    const response = await api.delete(`/cadre/applications/${id}`);
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await api.get("/cadre", { params });
    return response.data;
  },

  submitApplication: async (data) => {
    const response = await api.post("/cadre/apply", data);
    return response.data;
  },

  submitApplicationWithFile: async (formData) => {
    const response = await api.post("/cadre/applications/submit", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },

  getUserApplication: async () => {
    const response = await api.get("/cadre/applications/my-application");
    return response.data;
  },

  getMemberPanels: async (id) => {
    const response = await api.get(`/cadre/${id}/panels`);
    return response.data;
  },

  updateConflictOfInterest: async (id, status) => {
    const response = await api.put(`/cadre/${id}/conflict`, {
      status,
      disclosures: "", // Keep for backward compatibility
    });
    return response.data;
  },
};

export default cadreAPI;
